export default "__VITE_ASSET__COyWf0u5__"